import React, { useEffect, useState } from "react";
import { Col, Form, Input } from "antd";
import { useStateValue } from "../../state";
import { InputPreco, SelectPaginacao } from "../../components";
import { selectPaginadoActions } from "../../actions";
import DrawerTipoUrgencia from "../tipoUrgencia/drawer";
import InputNumber from "rc-input-number";

export default function TabDadosOSVeiculo({ formulario, dadosEditando }) {

    const [{ manutencao }, dispatch] = useStateValue();
    const [openDrawerTipoUrgencia, setOpenDrawerTipoUrgencia] = useState(false);

    useEffect(() => {
        if (dadosEditando) {
            let lista = [];
            if (dadosEditando.fun_id) {
                lista.push({ name: "fun_id", campo: "Filtro", value: dadosEditando.fun_id });
            }
            if (dadosEditando.tpu_id) {
                lista.push({ name: "tpu_id", campo: "Filtro", value: dadosEditando.tpu_id });
            }
            if (dadosEditando.orv_kmatual) {
                lista.push({ name: "orv_kmatual", campo: "Filtro", value: dadosEditando.orv_kmatual });
            }

            if (lista.length > 0) dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
            formulario.setFieldsValue(dadosEditando);
        }
    }, [dadosEditando, formulario]);


    function salvandoDadosTipoUrgencia(retorno) {
        let lista = [];
        if (retorno) {
            lista.push({ name: "tpu_id", campo: "Codigo", value: retorno.tpu_id });
            dispatch({ type: selectPaginadoActions.CHANGE, data: { itens: lista } });
        }
    }

    return (
        <div>
            <Form form={formulario} layout="vertical">

                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Form.Item label="Funcionário Responsável" name="fun_id">
                        <SelectPaginacao url="Funcionario/Listar"
                            allowClear={true}
                            selecionarRegUnico={"fun_id"}
                            nameLabel="pes_nome"
                            nameValue="fun_id"
                            placeholder="Selecione o funcionário Responsável"
                            form={formulario}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Form.Item label="Urgência" name="tpu_id">
                        <SelectPaginacao url="TipoUrgencia/Listar"
                            allowClear={true}
                            selecionarRegUnico={"tpu_id"}
                            nameLabel="tpu_descricao"
                            nameValue="tpu_id"
                            placeholder="Selecione a Urgência"
                            form={formulario}
                            funcaoIncluir={() => setOpenDrawerTipoUrgencia(true)}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                    <Form.Item label="KM Atual do Veículo" name="orv_kmatual">
                       <InputNumber placeholder="Informe a quilometragem"/>
                    </Form.Item>
                </Col>
                <Col span={40}>
                    <Form.Item label="Descrição do problema relatado pelo cliente" name="orv_descricaoproblema" rules={[{ required: true, message: 'Informe o problema relatado pelo cliente!' }]}>
                        <Input.TextArea
                            autoSize={{
                                minRows: 2,
                                maxRows: 6,
                            }}
                            maxLength={500}
                            placeholder="Relatos do problema conforme descrito pelo cliente" />
                    </Form.Item>
                </Col>
                <Col span={40}>
                    <Form.Item label="Descrição do serviço realizado pelo funcionário" name="orv_descricaoservico">
                        <Input.TextArea
                            autoSize={{
                                minRows: 2,
                                maxRows: 6,
                            }}
                            maxLength={500}
                            placeholder="Descrição do serviço conforme descrito pelo tecnico" />
                    </Form.Item>
                </Col>
            </Form>
            <DrawerTipoUrgencia openDrawer={openDrawerTipoUrgencia} setOpenDrawer={setOpenDrawerTipoUrgencia} retornoSalvar={salvandoDadosTipoUrgencia} />
        </div>
    )
}